import { csColorAction } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { parseCssVariable } from 'elements/_style-guide/parse-css-variable.js'
import { wrapCustomCss } from 'elements/_style-guide/wrap-custom-css.js'
import { css, CSSResult, CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './colors.style.js'


type ShadowCategory = [name: string, group: Record<string, CSSResult>]
type ShadowGroup = [name: string, cssResult: CSSResult]

const csShadow = {
  default: css`var(--cs-shadow-default, 0 5px 10px 0 rgb(0 0 0 / 15%))`,
  downSmall: css`var(--cs-shadow-down-small, 0 2px 3px 0 rgb(0 0 0 / 5%))`,
  upSmall: css`var(--cs-shadow-up-small, 0 -2px 3px 0 rgb(0 0 0 / 5%))`,
  downLarge: css`var(--cs-shadow-down-large, 0 20px 20px 0 rgb(0 0 0 / 15%))`,
  slideIn: css`var(--cs-shadow-slide-in, -10px 0 20px 0 rgb(0 0 0 / 15%))`,
  textShadow: css`var(--cs-shadow-text-shadow, 0 5px 10px 0 rgb(0 0 0 / 50%))`,
}

const csFocus = {
  default: css`var(--cs-shadow-focus-default, 0 0 4px 0 ${csColorAction.secondary})`,
  primary: css`var(--cs-shadow-focus-primary, 0 0 4px 0 ${csColorAction.primary})`,
  secondary: css`var(--cs-shadow-focus-secondary, 0 0 4px 0 ${csColorAction.secondary})`
}


@customElement('cssg-shadows')
export class CSSGShadows extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: Object, attribute: 'shadow' })
  customShadow: object = {}
  @property({ type: Object, attribute: 'focus' })
  customFocus: object = {}

  private shadowCategories: Record<string, Record<string, CSSResult>> = {}

  override connectedCallback() {
    super.connectedCallback()
    this.shadowCategories = {
      shadow: { ...csShadow, ...wrapCustomCss(this.customShadow) },
      focus: { ...csFocus, ...wrapCustomCss(this.customFocus) },
    }
  }

  private renderGroup = ([name, cssResult]: ShadowGroup) => {
    const parsedCssVariable = parseCssVariable(cssResult.cssText, this)
    return html`
      <div>
        <div class="swatch" style="box-shadow: ${cssResult};">
          ${parsedCssVariable.value}
        </div>
        <cse-text variant="heading-4" class="swatch-title">
          ${name}
        </cse-text>
        <cse-text variant="body-s">
          ${parsedCssVariable.variable}
        </cse-text>
      </div>
    `
  }

  private renderCategory = ([name, group]: ShadowCategory) => {
    return html`
      <cse-text variant="caption-m" class="swatch-group-name">
        ${name}
      </cse-text>
      <div class="swatch-group">
        ${Object.entries(group).map(this.renderGroup)}
      </div>
      <div class="divider"></div>
    `
  }

  override render() {
    return Object.entries(this.shadowCategories).map(this.renderCategory)
  }
}


declare global {
  interface HTMLElementTagNameMap {
    'cssg-shadows': CSSGShadows
  }
}
